export default __webpack_public_path__ + "static/Row 4.2_Pentecost Methodist Church Kindergarten-576331c9c5232b8bba1abaea6787e6e6.jpg";